/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './EcsPortal.module.scss';
import { getEcsClearanceHistory } from '../../api';
import { useAuth } from '../../contexts/auth';
import { clickTracker, getSourceValue, handleRedirection } from '../../lib/common';

export default function ECSClearanceHistory({ projectId }) {
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const [data, setData] = useState({});
  const [date, setDate] = useState('');
  const [url, seturl] = useState('');
  const [noData, setNoData] = useState('');
  const source = getSourceValue();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));

  const handleViewMore = async (rurl) => {
    handleRedirection(source, rurl);
  };

  useEffect(() => {
    const handleGetEcsClearanceHistory = async () => {
      const res = await getEcsClearanceHistory({
        pid: projectId === 'csportal' ? selectedBusiness?.parentid : selectedBusinessGenio?.parentId || '',
        docid: projectId === 'csportal' ? selectedBusiness.docid : selectedBusinessGenio?.docId || '',
        city:
          projectId === 'csportal'
            ? selectedBusiness.data_city
            : selectedBusinessGenio?.city
              ? encodeURIComponent(selectedBusinessGenio?.city)
              : '',
        shortUrl: projectId === 'csportal' ? selectedBusiness.shorturl || '' : selectedBusinessGenio?.shorturl || '',
        projectId,
        mobile: profile?.mobile || '',
      });
      if (Object.keys(res?.result).length === 0) setNoData('No Data Found for ECS clearance');
      else {
        setData(res?.result?.data || {});
        setDate(res?.result?.date);
        seturl(res?.result?.url);
      }
    };
    handleGetEcsClearanceHistory();
  }, []);
  return (
    <div>
      {noData ? (
        <div className={`${styles.Accordion__DotItem__Text} font12 fw400 color777`}>{noData}</div>
      ) : (
        <>
          <>
            <div className="font12 fw700 color111 mt-2">Here’s your latest ECS clearance information</div>
            <div className="font12 fw400 color111">
              Clearance Date : <span className="fw500">{date}</span>
            </div>

            <ul className={`${styles.Accordion__PricingItems} mt-10`}>
              {data &&
                Object.keys(data).map((item) => {
                  return (
                    <>
                      {item.toLowerCase() !== 'total' && (
                        <li className={`${styles.Accordion__PricingItem} ${styles.PricingItem__Heading}`}>
                          <label
                            className={`${styles.PricingItem__Lable}  font12 fw400 ${
                              item.toLowerCase() === 'package' ? 'color111' : 'color777'
                            }`}
                          >
                            {item}
                          </label>
                          <div
                            className={`${styles.PricingItem__Text} font12 ${
                              item.toLowerCase() === 'package' ? 'fw500' : 'fw400'
                            } color111`}
                          >
                            {data[item]}
                          </div>
                        </li>
                      )}
                    </>
                  );
                })}
              <li className={`${styles.Accordion__PricingItem} ${styles.PricingItem__Footer} `}>
                <label className={`${styles.PricingItem__Lable} font12 fw400 color111`}>Total</label>
                <div className={`${styles.PricingItem__Text} font12 fw600 color111`}>{data.Total}</div>
              </li>
            </ul>
          </>
          {projectId === 'csportal' && (
            <div
              aria-label="ecs_view_more_click"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              className={`${styles.Helpful__Left}`}
              onClick={() => handleViewMore(url || '')}
            >
              <div className={`${styles.Helpful__LeftAnchor}`}>
                <span
                  aria-label="ecs_view_more_btn"
                  tabIndex={0}
                  role="button"
                  onKeyDown={() => {}}
                  className="font11 fw500 color007 pr-4"
                  onClick={async () => {
                    await clickTracker(`FAQ_clearanceinfo_viewmore`, `ecs_FAQ_clearanceinfo`);
                  }}
                >
                  View More
                </span>
                <span className={`${styles.LeftAnchor__Icon} csicon`} />
              </div>
            </div>
          )}
        </>
      )}
      {/* <div style={{ float: 'right' }}></div> */}
    </div>
  );
}
ECSClearanceHistory.propTypes = {
  projectId: PropTypes.string,
  // activeIndex: PropTypes.number,
};
